const main = () => {
    if (document.querySelector('#page-sold-result') === null) return;
    document.querySelector('.pg-header__search-type select').addEventListener('change', (e) => {
        e.currentTarget.closest('form').submit();
    });
    console.log("ok");
}

export default main;